import { getPartnerFromParticipant } from 'modules/boards/utils';
import { Partner, Society } from 'types';
import getPartnerNDPercent from 'utils/getPartnerNDPercent';

const FAVOR_VOTE = 'YES';
const AGAINST_VOTE = 'NO';
const ABSTENTION_VOTE = 'ABS';

const getGetTotalVotesNDPercent = (
  order: any,
  participants: any[],
  actualSociety: Society,
  partners: Partner[],
  societySharesCount?: number
) => {
  let result = 0;

  const orderId = order?._id;

  participants?.forEach((participant) => {
    const hasVoted = participant?.votes?.some(
      (vote: any) => vote.order === orderId
    );
    if (hasVoted) {
      const partner = getPartnerFromParticipant(participant, partners);
      const ndPercentage = societySharesCount
        ? ((participant?.sharesCount || 0) * 100) / societySharesCount
        : getPartnerNDPercent(partner, actualSociety);

      result += ndPercentage || 0;
    }
  });

  return result;
};

const getOrderPercentage = (
  orderId: string,
  participants: any[],
  actualSociety: Society,
  partners: Partner[],
  voteType: string,
  societySharesCount?: number
) => {
  let result = 0;

  participants?.forEach((participant) => {
    const orderVote = participant?.votes?.find(
      (vote: any) => vote.order === orderId
    );
    const partner = getPartnerFromParticipant(participant, partners);
    const ndPercentage = societySharesCount
      ? ((participant?.sharesCount || 0) * 100) / societySharesCount
      : getPartnerNDPercent(partner, actualSociety);

    if (orderVote?.vote === voteType) {
      result += ndPercentage || 0;
    }
  });
  return result;
};

export const getOrderVotesData = (
  order: any,
  participants: any[],
  actualSociety: Society,
  partners: Partner[],
  societySharesCount?: number
) => {
  const orderId = order?._id;

  const favorPercentage = getOrderPercentage(
    orderId,
    participants,
    actualSociety,
    partners,
    FAVOR_VOTE,
    societySharesCount
  );

  const againstPercentage = getOrderPercentage(
    orderId,
    participants,
    actualSociety,
    partners,
    AGAINST_VOTE,
    societySharesCount
  );

  const abstentionPercentage = getOrderPercentage(
    orderId,
    participants,
    actualSociety,
    partners,
    ABSTENTION_VOTE,
    societySharesCount
  );

  const totalVotesNDPercent = getGetTotalVotesNDPercent(
    order,
    participants,
    actualSociety,
    partners,
    societySharesCount
  );

  return {
    id: orderId,
    favor: (favorPercentage * 100) / totalVotesNDPercent,
    against: (againstPercentage * 100) / totalVotesNDPercent,
    abstention: (abstentionPercentage * 100) / totalVotesNDPercent,
    totalVotesNDPercent,
  };
};
